import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class GlobalErrorHandlerService {
    constructor() {}

    getGlobalErrorHandler$(): Observable<{}> {
        return of({});
    }
}
